import React from "react";
import "./Profile.scss";

function Profile() {
  return <div className="Profile">Profile page</div>;
}

export default Profile;
